import logsHandler from "../../services/Logs";

export default {
    async loadLogs({commit, dispatch}, payload) {
        return logsHandler.all(payload);
    },
    async loadRepublishLogs({commit, dispatch}, payload) {
        return logsHandler.republishLogsAll(payload);
    },
    async republishMarkedAsRead({commit, dispatch}, payload) {
        return logsHandler.republishMarkedAsRead(payload);
    },
}
